import React, { useState } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../reducer/store";

import Person from "../assets/icons/person.svg";
import Calender from "../assets/icons/calender-w.svg";
import Bus from "../assets/icons/bus.svg";
import Driving from "../assets/icons/driving.svg";

import Arrival from "../assets/icons/arrival.svg";
import Departure from "../assets/icons/departure.svg";
import Seat from "../assets/icons/seat.svg";
import Time from "../assets/icons/time.svg";

import Trip from "../assets/images/trip-bus.png";
import ModifyPopup from "../components/modal/ModifyPopup";
import SelectSeatPopup from "../components/modal/SelectSeatPopup";

const Booking = () => {
  const bookings = useSelector(
    (state: IRootState) => state.booking.value.booking
  );

  const [isModify, setIsModify] = useState(false);
  const [isViewSeat, setIsViewSeat] = useState(false);
  return (
    <>
      {isModify && <ModifyPopup onClose={() => setIsModify(false)} />}
      {isViewSeat && <SelectSeatPopup onClose={() => setIsViewSeat(false)} />}
      <div className="bg-[#F9F9F9]">
        <div className="bg-[#620005]">
          <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-white">
            <div className="flex flex-col md:flex-row gap-x-20 gap-4">
              <div className="head font-semibold text-xl">Journey Details:</div>
              <div className="flex flex-col text-sm font-medium md:w-[50%] gap-8">
                <div className="flex head text-xl gap-2">
                  <div className="">{bookings.from}</div>
                  <div className="flex items-center w-full justify-center">
                    <div className="border-dashed border w-full"></div>
                    <img src={Bus} alt="" />
                    <div className=" border-dashed border w-full"></div>
                  </div>
                  <div className="">{bookings.to}</div>
                </div>
                <div className="grid grid-cols-3 md:grid-cols-4 gap-2 w-full justify-between">
                  <div className="flex gap-2">
                    <img src={Person} alt="" />{" "}
                    <div className="">{bookings.adult} Adult</div>
                  </div>
                  <div className="flex gap-2">
                    <img src={Person} alt="" />{" "}
                    <div className="">{bookings.children} Child</div>
                  </div>
                  <div className="flex gap-2">
                    <img src={Calender} alt="" />{" "}
                    <div className="">{bookings.returnDate}</div>
                  </div>
                  <div className="flex gap-2">
                    <img src={Driving} alt="" />{" "}
                    <div className="">Single Trip </div>
                  </div>
                </div>
                <button
                  className="outline-none h-11 flex items-center justify-center px-10 bg-[#B9000A] w-fit"
                  onClick={() => setIsModify(true)}
                >
                  Modify
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto flex flex-col px-4 py-10">
          <div className="flex items-center text-2xl font-bold head gap-3 py-10 px-4">
            <span>Trip</span>
            <span className="text-pry">Selection</span>
            <div className="h-2 w-4 bg-black"></div>
          </div>
          {/* Bus */}
          <div className="flex flex-col md:flex-row">
            <img src={Trip} alt="" />
            <div className="flex flex-col justify-between md:p-10 p-4 gap-3 w-full bg-white">
              <div className="head font-semibold text-xl">Hiace Ultra</div>
              <div className="flex justify-between">
                <div className="flex flex-col gap-3">
                  <div className="flex items-start gap-3">
                    <img src={Departure} alt="" />
                    <div className="flex flex-col gap-2">
                      <div className="text-[#757575] text-xs">DEPARTURE</div>
                      <div className="font-semibold text-base">
                        Lagos - Jibowu
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <img src={Seat} alt="" />
                    <div className="text-sm font-semibold">
                      7 Seats available
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <img src={Person} alt="" />
                    <div className="text-sm font-semibold">1 adult</div>
                  </div>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="flex items-start gap-3">
                    <img src={Arrival} alt="" />
                    <div className="flex flex-col gap-2">
                      <div className="text-[#757575] text-xs">ARRIVAL</div>
                      <div className="font-semibold text-base">
                        Lagos - Jibowu
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <img src={Time} alt="" />
                    <div className="text-pry text-sm font-semibold">6:00am</div>
                  </div>
                </div>
                <div className="hidden md:flex flex-col items-end gap-4">
                  <div className="head font-semibold text-xl">N24,500</div>
                  <button
                    className="outline-none h-11 flex items-center justify-center text-white px-8 bg-[#B9000A] w-fit"
                    onClick={() => setIsViewSeat(true)}
                  >
                    View Seats
                  </button>
                </div>
              </div>
              <hr className="block md:hidden" />
              <div className="flex flex-col md:hidden items-center gap-4">
                <div className="head font-semibold text-2xl">N24,500</div>
                <button
                  className="outline-none h-11 flex items-center justify-center text-white px-8 bg-[#B9000A] w-full"
                  onClick={() => setIsViewSeat(true)}
                >
                  View Seats
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;
